import axios from "@/api/interceptor_tuwen";

/**
 * 财务管理
 * @param params
 * @returns
 */

// 充值操作
export function postFinancesRecharge(data: any) {
  return axios.post("/agent/finances/recharge", data);
}

// 充值记录
export function getFundsRecord(params: any) {
  return axios.get("/agent/finances/recharge-record", { params });
}

// 充值统计
export function getFundsRecordTotal(params: any) {
  return axios.get("/agent/finances/recharge-total", { params });
}

// 退款记录
export function getFundsRefundRecord(params: any) {
  return axios.get("/agent/finances/refund-record", { params });
}

// 退款统计
export function getFundsRefundRecordTotal(params: any) {
  return axios.get("/agent/finances/refund-total", { params });
}

// 扣费记录
export function getFinanceDeduction(params: any) {
  return axios.get("/agent/finances/deduction-record", { params });
}

// 扣费统计
export function getFinanceDeductionTotal(params: any) {
  return axios.get("/agent/finances/deduction-total", { params });
}

// 二代充值记录
export function getFundsAgent2(params: any) {
  return axios.get("/agent/finances/agent2-recharge-record", { params });
}

// 二代充值统计
export function getFundsAgent2Total(params: any) {
  return axios.get("/agent/finances/agent2-recharge-total", { params });
}

// 二代退款记录
export function getFundsAgent2RefundRecord(params: any) {
  return axios.get("/agent/finances/agent2-refund-record", { params });
}

// 二代退款统计
export function getFundsAgent2RefundRecordTotal(params: any) {
  return axios.get("/agent/finances/agent2-refund-total", { params });
}

// 二代扣费记录
export function getFinanceAgent2Deduction(params: any) {
  return axios.get("/agent/finances/agent2-deduction-record", { params });
}

// 二代扣费统计
export function getFinanceAgent2DeductionTotal(params: any) {
  return axios.get("/agent/finances/agent2-deduction-total", { params });
}